import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_HISTOGRAMA_INGRESO_POR_CEREAL } from '../../../../config/tables'

export function HistogramaIngresoView () {
  return (
    <MuiTable id={TABLA_HISTOGRAMA_INGRESO_POR_CEREAL} />
  )
}
